/** Seconds between a successful purge and the automatic page refresh. */
export const PURGE_COUNTDOWN_SECONDS = 10

/** One toast id for the whole countdown, so each tick updates it in place instead of stacking. */
export const PURGE_TOAST_ID = 'purge-checkpoint-countdown'
